export default "__VITE_ASSET__CN1Mz1aE__"